import { amber, blueGrey, green, grey } from '@mui/material/colors';
import { createTheme } from '@mui/material/styles';

const backgroundColor = "#FFFFFF";

export const theme = createTheme({
    /*overrides:{
        MuiCssBaseline: {
            "@global":{
                body: {
                    fontSize: "40px",
                },
            },
        },
    },*/
    palette: {
        primary: {
            // main: "#1565c0", //blue
            // main: "#C10C46", //pink
            main: "#8D7C57", //gold
        },
        secondary: {
            main: "#2F2F2F", //darkgrey
        },
        background: {
            default: "#FFFFFF", //white
            // layout: "#1565c0", //blueGrey[900],//"#263238",
            layout: "#EFEFEF", //appbar bg
        },
    },
    typography: {
        mainContent: {
            backgroundColor: { backgroundColor },
            width: "100%",
            minHeight: "calc(100vh - 80px)",
            flexGrow: 1,
            padding: "10px",
            marginTop: "80px",
            marginRight: "10px",
            marginLeft: "260px",
        },
        fontFamily: 'Pretendard-Regular',
    },
    link: {
        logo: {
            textDecoration: "none",
            color: "#212121", //appbar text
        },
    },
    custom: {
        gridSpacing: "3",
        drawerWidth: "260",
        appDrawerWidth: "320",
        drawerTextColor: "#212121",
        // drawerBgColor: "#eeeeee",
        drawerBgColor: "#2F2F2F", //darkgrey
        appbarBgColor: "#EFEFEF", //lightgrey
        // drawerTextDefaultColor: "#212121", //black
        drawerTextDefaultColor: "#FFFFFF", //white
        drawerTextHighColor: "#d50000",//red
    },
});